import {
  faMobileAlt,
  faSave,
  faUndo,
  faUniversity,
} from "@fortawesome/free-solid-svg-icons";
import classNames from "classnames";
import React, { useEffect, useState } from "react";
import NumberFormat from "react-number-format";
import {
  Button,
  Col,
  Fade,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Spinner,
} from "reactstrap";
import { create, update } from "../../../../helpers/api/banks";
import { SUCCESS_RESPONSE } from "../../../../helpers/codeResponses/codes";
import handleErrorMessage from "../../../../helpers/errors/handleErrorMessage";
import WizardError from "../../../auth/register/WizardError";
import ButtonIcon from "../../../common/ButtonIcon";
import Flex from "../../../common/Flex";
import { Toast } from "../../../UI/toast/Toast";

const LeadDetailsModal = ({
  isOpen,
  setIsOpen,
  method: met,
  setSelected,
  mutate = () => {},
}) => {
  const toggle = () => {
    setIsOpen(!isOpen);
    setSelected(null);
  };

  const [submitting, setSubmitting] = useState(false);

  const [method, setMethod] = useState(null);
  // eslint-disable-next-line
  const [bankInfo, setBankInfo] = useState({
    bank_name: "",
    owner_name: "",
    account_number: null,
    prefix: "V",
    dni: "",
  });
  // eslint-disable-next-line

  const [errors, setErrors] = useState(null);

  const closeBtn = (
    <>
      <Button
        className="close font-weight-normal bg-transparent border-0 shadow-none"
        onClick={toggle}
      >
        &times;
      </Button>
    </>
  );

  const save = (e) => {
    e.preventDefault();
    if (method === "bank") {
      if (
        errors.bank_name ||
        errors.owner_name ||
        errors.account_number ||
        errors.dni
      ) {
        return;
      }
      setSubmitting(true);
      if (!!!met) {
        create({
          ...bankInfo,
          name: bankInfo.bank_name,
          owner_dni: `${bankInfo.prefix}${bankInfo.dni}`,
        })
          .then(({ code }) => {
            if (code === SUCCESS_RESPONSE.CREATED) {
              setBankInfo({
                bank_name: "",
                owner_name: "",
                account_number: "",
                dni: "",
              });
              setErrors({
                bank_name: null,
                owner_name: null,
                account_number: null,
                dni: null,
              });
              mutate();
              setIsOpen(false);
              Toast.fire({
                title: "Se ha guardado la información de su cuenta bancaria.",
                type: "success",
              });
            }
          })
          .catch((err) => handleErrorMessage(err))
          .finally(() => setSubmitting(false));
      } else {
        update(met?.bank_id, {
          ...bankInfo,
          name: bankInfo.bank_name,
          owner_dni: `${bankInfo.prefix}${bankInfo.dni}`,
        })
          .then(({ code }) => {
            if (code === SUCCESS_RESPONSE.OK) {
              setBankInfo({
                bank_name: "",
                owner_name: "",
                account_number: "",
                dni: "",
              });
              setErrors({
                bank_name: null,
                owner_name: null,
                account_number: null,
                dni: null,
              });
              mutate();
              setIsOpen(false);
              Toast.fire({
                title:
                  "Se ha actualizado la información de su cuenta bancaria.",
                type: "success",
              });
            }
          })
          .catch((err) => handleErrorMessage(err))
          .finally(() => setSubmitting(false));
      }
    }
  };

  return (
    <>
      <Modal
        isOpen={isOpen}
        toggle={toggle}
        centered
        modalClassName="theme-modal"
      >
          <ModalHeader
            toggle={toggle}
            tag="div"
            className="px-card bg-light border-0 flex-between-center"
            close={closeBtn}
          >
            <h5 className="mb-0">
             Detalles
            </h5>
          </ModalHeader>
          <ModalBody className="px-card pb-card pt-card fs--1">
            <Fade>
            <Row>
  <Col>
    <Row form>
      <Col tag={FormGroup}>
        <Label>Nombres</Label>
        <p>{met?.name}</p>
      </Col>
    </Row>
    <Row form>
      <Col tag={FormGroup}>
        <Label>Correo electrónico</Label>
        <p>{met?.email}</p>
      </Col>
      <Col tag={FormGroup}>
        <Label>Teléfono</Label>
        <p>{met?.phone}</p>
      </Col>
    </Row>
    <Row form>
      <Col tag={FormGroup}>
        <Label>Rol</Label>
        <p>{met?.rol}</p>
      </Col>
      <Col tag={FormGroup}>
        <Label>Número de propiedades</Label>
        <p>{met?.numero_propiedades}</p>
      </Col>
    </Row>
    <Row form>
      <Col tag={FormGroup}>
        <Label>País</Label>
        <p>{met?.pais}</p>
      </Col>
      <Col tag={FormGroup}>
        <Label>Ciudad</Label>
        <p>{met?.ciudad}</p>
      </Col>
    </Row>
  </Col>
</Row>
            </Fade>
          </ModalBody>
          <ModalFooter
            tag={Flex}
            justify="end"
            className="bg-light px-card border-top-0"
          >
            <ButtonIcon
              icon={faUndo}
              onClick={() => {
                toggle();
                setMethod(null);
                setErrors(null);
    
              }}
              className="mr-3 px-5"
              color="falcon-default"
              size="md"
              transform="down-1 shrink-4"
            >
              <span>Volver</span>
            </ButtonIcon>
          </ModalFooter>
    
      </Modal>
    </>
  );
};

export default LeadDetailsModal;
